import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Login from '@pages/UserLogin';
import Signin from '@pages/Signin';
import SettleContract from "@pages/Settle/SettleContract.jsx";
import App from './App';

export default () => (
    <Router>
        <Switch>
            <Route exact path="/" render={() => <Redirect to="/cps/index" push />} />
            <Route path="/cps" component={App} />
            <Route path="/login" component={Login} />
            <Route path="/signin" component={Signin} />
            <Route path="/contract" component={SettleContract} />
            <Route component={App}/>
        </Switch>
    </Router>
)